




import { Vue, Component } from 'vue-property-decorator'

import RoomDetail from '@/components/RoomDetail.vue'

@Component({
  components: {
    RoomDetail
  }
})
export default class RoomDetailView extends Vue {
}
